import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import React, { useMemo } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introBottomVariants, introLeftVariants, introOpacityVariants } from '@/config/const'
import ShortcutIncentive from '@/modules/home/ShortcutIncentive'
import { getHomeIncentive } from '@/services/home'
import { BasicHeaders } from '@/types/common'
import { useAppSelector } from '@/utils/hooks'

const Benefit: React.FC = () => {
  const router = useRouter()

  const request: BasicHeaders = useMemo(() => {
    return {
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: incentive } = useAppSelector(getHomeIncentive.select(request))

  return (
    <section className='relative overflow-hidden'>
      <div className='flex h-full w-full justify-center bg-neutral-disable'>
        <div className='relative z-[3] flex flex-col gap-y-8 py-8 lg:gap-y-11 lg:py-12.5'>
          <div className='container flex flex-col items-center gap-4 text-center'>
            <motion.h2
              className='text-2xl font-bold text-dark lg:text-[32px] lg:leading-[48px]'
              initial='hide'
              whileInView='show'
              viewport={{ once: true }}
              variants={introLeftVariants}
            >
              {incentive?.data.title}
            </motion.h2>
            <motion.div
              className='description max-w-[1139px] break-words text-base font-normal leading-normal text-dark lg:text-xl lg:leading-[30px]'
              dangerouslySetInnerHTML={{ __html: String(incentive?.data.description) }}
              initial='hide'
              whileInView='show'
              viewport={{ once: true }}
              variants={introOpacityVariants}
            />
          </div>

          <div className='container flex flex-col gap-y-6 lg:gap-y-11'>
            <motion.div
              className='w-full'
              initial='hide'
              whileInView='show'
              viewport={{ once: true }}
              variants={introBottomVariants}
            >
              {incentive?.data.imageFiles && (
                <ImageByWidthDevice
                  images={incentive?.data.imageFiles}
                  alt={incentive?.data.imageFiles.desktop.fileName ?? ''}
                  className='w-full rounded'
                />
              )}
            </motion.div>

            <ShortcutIncentive />
          </div>
        </div>
      </div>
      <div className='absolute bottom-0 z-[1] h-[370px] w-full bg-white md:h-[400px] lg:h-[474px]' />
    </section>
  )
}

export default Benefit
